import { cachedDashboardGet } from "./dashboardRequestCache";
import { SalesComparisonPeriod } from "../components/TimelyComparisonCharts/types";
import {
  TimelyComparisonSeriesApiItem,
  SalesTimelyComparisonChartsResponse,
} from "./salesTimelyComparisonDashboardApi";

export type ServiceTimelyComparisonPeriod = SalesComparisonPeriod;

interface ApiResponseEnvelope<T> {
  status: number;
  success: boolean;
  message: string;
  data: T;
}

export const fetchServiceTimelyComparisonCharts = async (
  period: ServiceTimelyComparisonPeriod,
): Promise<SalesTimelyComparisonChartsResponse> => {
  const response = await cachedDashboardGet<
    ApiResponseEnvelope<SalesTimelyComparisonChartsResponse>
  >("/dashboard/service/timely-comparison/charts",
    { period },
  );

  return response.data;
};


